var exports = {
  "uF": "PermissionComponents.module__stateButtonsContainer___NmZFYk",
  "ev": "PermissionComponents.module__stateButton___NmZFYk",
  "uz": "PermissionComponents.module__stateButtonDisabled___NmZFYk",
  "Jj": "PermissionComponents.module__stateButtonEnabled___NmZFYk",
  "c$": "PermissionComponents.module__stateButtonDeny___NmZFYk",
  "D5": "PermissionComponents.module__stateButtonNeutral___NmZFYk",
  "N$": "PermissionComponents.module__stateButtonAllow___NmZFYk",
  "Z9": "PermissionComponents.module__stateButtonInactive___NmZFYk",
  "Ds": "PermissionComponents.module__stateDivider___NmZFYk",
  "oq": "PermissionComponents.module__overwriteToggle___NmZFYk",
  "rt": "PermissionComponents.module__overwriteToggleDense___NmZFYk",
  "HC": "PermissionComponents.module__overwriteToggleContent___NmZFYk",
  "_O": "PermissionComponents.module__overwriteToggleTitle___NmZFYk",
  "Jw": "PermissionComponents.module__overwriteToggleTitleEnabled___NmZFYk",
  "Mr": "PermissionComponents.module__overwriteToggleTitleDisabled___NmZFYk",
  "GE": "PermissionComponents.module__overwriteToggleDescription___NmZFYk",
  "fD": "PermissionComponents.module__overwriteToggleActions___NmZFYk",
  "Wk": "PermissionComponents.module__categoryContainer___NmZFYk",
  "yj": "PermissionComponents.module__categoryDivider___NmZFYk",
  "p8": "PermissionComponents.module__categoryTitle___NmZFYk",
  "LW": "PermissionComponents.module__categoryPermissions___NmZFYk",
  "wk": "PermissionComponents.module__categoryPermissionsDense___NmZFYk",
  "n2": "PermissionComponents.module__categoryPermissionsGrid___NmZFYk",
  "HF": "PermissionComponents.module__roleToggle___NmZFYk",
  "_y": "PermissionComponents.module__roleToggleDense___NmZFYk",
  "vx": "PermissionComponents.module__tooltipTriggerBlock___NmZFYk",
  "RO": "PermissionComponents.module__tooltipTriggerInline___NmZFYk",
  "Iz": "PermissionComponents.module__roleCategoryContainer___NmZFYk",
  "mj": "PermissionComponents.module__roleCategoryDivider___NmZFYk",
  "rh": "PermissionComponents.module__roleCategoryTitle___NmZFYk",
  "XC": "PermissionComponents.module__roleCategoryPermissions___NmZFYk",
  "MC": "PermissionComponents.module__roleCategoryPermissionsDense___NmZFYk",
  "bE": "PermissionComponents.module__roleCategoryPermissionsGrid___NmZFYk",
};

module.exports = exports;
